import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { fetchCleanerChat, updateUnreadChatCount } from "sr/redux/reducers/cleanerChat";
import { AppDispatch } from "sr/redux/store";
import { updateMessage } from "sr/utils/api/cleaner/updateMessage";
import { useAuth } from "../module/auth";
import { fetchChat, markNotificationAsRead } from "sr/redux/reducers/notification";
import { fetchCompanyChat } from "sr/redux/reducers/companychat";
import { markCleanerNotificationAsRead } from "sr/redux/reducers/cleanerNotification";

export const DisplayMessageReceiver = ({item, fetchUnreadCount=null, fetchUnreadApplication=null, clearUnreadForJob=null}) => {
    const dispatch = useDispatch<AppDispatch>();
    const {userType} = useAuth()
    const [userId, setUserId] = useState<string>('')

    useEffect(()=>{
      const {user_id} = getUserDetails()
      setUserId(user_id)
    },[])
  
     const updateReadMessage = async (id:string)=> {
    if(!id) return
    if (id.startsWith('temp_')) return;
    try {
            const payload = {
              id:id,
              readed:true
              }
              const res = await updateMessage(payload)
              if(res?.success===true){
                const payloadArgs = {
                    id: id,
                    jobId: typeof item.job_id === 'string' ? item.job_id : (item.job_id?._id || item.job_id?.id),
                    senderId: typeof item.sender_id === 'string' ? item.sender_id : (item.sender_id?._id || item.sender_id?.id),
                    messageText: item.message,
                    fileId: typeof item.file_id === 'string' ? item.file_id : (item.file_id?._id || item.file_id?.id)
                };

                if (userType === 'cleaner') {
                   dispatch(fetchCleanerChat({cleanerId:userId}))
                   dispatch(markCleanerNotificationAsRead(payloadArgs));
                   if(fetchUnreadApplication) await fetchUnreadApplication()
                } else if (userType === 'company') {
                   dispatch(fetchCompanyChat({companyId:userId}))
                   dispatch(markNotificationAsRead(payloadArgs));
                }

                if(fetchUnreadCount)  await fetchUnreadCount(userId)
                if (clearUnreadForJob) clearUnreadForJob(item?.job_id?._id)
              }
            }catch(e){
    
            }
           }
           useEffect(()=>{
            if(item?._id && item?.readed===false && userId){
                updateReadMessage(item?._id)
            }
            
           },[item?._id, item?.readed, userId])
  return (<div className='text-[#595959]'>
    {item?.message}
     </div>);
};
